import { render, staticRenderFns } from "./ApprovalComponent.vue?vue&type=template&id=b0d011bc&"
import script from "./ApprovalComponent.vue?vue&type=script&lang=js&"
export * from "./ApprovalComponent.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalComponent.vue?vue&type=style&index=0&id=b0d011bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports